"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertFeedType = exports.isFeedType = exports.DEFAULT_FEED_TYPE = void 0;
const feedTypes = ['sequence', 'epoch'];
exports.DEFAULT_FEED_TYPE = 'sequence';
function isFeedType(type) {
    return typeof type === 'string' && feedTypes.includes(type);
}
exports.isFeedType = isFeedType;
function assertFeedType(type) {
    if (!isFeedType(type)) {
        throw new TypeError('invalid feed type');
    }
}
exports.assertFeedType = assertFeedType;
